<template>
  <div class="info-box">
    <div class="head-box">
      <div class="c-flex-space-between c-flex-align-center">
        <p class="p1">{{ $t("user_center.my_share") }}</p>
        <div class="c-flex">
          <div class="btn1" style="font-size: 14px; padding: 0 10px;" @click="copyToClipboard(vipInfo.inviteCode)">{{$t("user_center.my_invite_code")}}：{{ vipInfo.inviteCode }}</div>
          <div class="btn2 ml12" @click="copyToClipboard(shareUrl)">{{ $t("user_center.copy_share_url") }}</div>
        </div>
      </div>
      <!-- <p class="p2 mt8">{{ $t("user_center.share_tips_val") }}</p> -->

      <div class="c-flex mt32">
        <!-- <div class="c-flex1 c-flex-column c-flex-align-center box-border-right">
          <p class="box-p6">{{ $t("partner.cumulativeRebate") }}</p>
          <p class="mt20">
            <span class="box-p7">{{ vipInfo.rewardFeeSum }}</span>
            <span class="box-p8 ml10">USDT</span>
          </p>
        </div> -->
        <div class="c-flex1 c-flex-column c-flex-align-center box-border-right">
          <p class="box-p6">{{ $t("partner.cumulativeCashback") }}</p>
          <p class="mt20">
            <span class="box-p7">{{ vipInfo.rewardWithdrawSum }}</span>
            <span class="box-p8 ml10">USDT</span>
          </p>
        </div>
        <div class="c-flex1 c-flex-column c-flex-align-center">
          <p class="box-p6">{{ $t("partner.cumulativeCashback1") }}</p>
          <p class="mt20">
            <span class="box-p7">{{ vipInfo.inviteeNormalSum }}</span>
          </p>
        </div>
        <!-- <div class="c-flex1 c-flex-column c-flex-align-center" v-if="this.user.vipLevel !== 'register'">
          <p class="box-p6">{{ $t("partner.rebateRatio") }}</p>
          <p class="mt20">
            <span class="box-p7">{{ vipInfo.upRewardFeeRatio }}</span>
          </p>
        </div> -->
      </div>
    </div>
    <div class="tab-box mt20">
      <div
        :class="{ sel: tableShow === 'invite_record' }"
        @click="tabChange('invite_record')"
      >
        {{ $t("partner.shareTab2") }}
      </div>
      <!-- <div
        :class="{ sel: tableShow === 'reward_record' }"
        @click="tabChange('reward_record')"
      >
        {{ $t("partner.shareTab3") }}
      </div> -->
    </div>
    <div
      class="box2 c-flex1 c-flex-column"
      v-if="tableShow === 'invite_record'"
    >
      <NoData v-if="inviteRecordTable.length <= 0" />
      <template v-else>
        <el-table
          :data="inviteRecordTable"
          style="width: 100%"
          header-cell-class-name="table-head"
          cell-class-name="table-cell"
        >
          <el-table-column :label="$t('partner.time')">
            <template slot-scope="scope">
              {{
                dateFormatter(
                  new Date(scope.row.createTime),
                  "yyyy-MM-dd hh:mm:ss",
                )
              }}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="userId" label="UID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="userName"
            :label="$t('partner.user_invited')"
          >
          </el-table-column>
          <el-table-column
            align="right"
            :label="$t('partner.reward_cash_amount')"
          >
            <template slot-scope="scope">
              {{ scope.row.rewardWithdraw }}&nbsp;USDT
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination-box"
          background
          layout="prev, pager, next"
          :total="inviteRecordTotal"
          @current-change="getInviteRecord"
          :current-page.sync="inviteRecordParam.pageNumber"
          :page-size="inviteRecordParam.pageSize"
        />
      </template>
    </div>
    <div
      class="box2 c-flex1 c-flex-column"
      v-if="tableShow === 'reward_record'"
    >
      <NoData v-if="rewardFeeTable.length <= 0" />
      <template v-else>
        <el-table
          :data="rewardFeeTable"
          style="width: 100%"
          header-cell-class-name="table-head"
          cell-class-name="table-cell"
        >
          <el-table-column :label="$t('partner.time')">
            <template slot-scope="scope">
              {{
                dateFormatter(
                  new Date(scope.row.createTime),
                  "yyyy-MM-dd hh:mm:ss",
                )
              }}
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="fromUserName"
            :label="$t('partner.user_invited')"
          >
          </el-table-column>
          <el-table-column
            sortable
            align="right"
            :label="$t('partner.reward_fee_money')"
          >
            <template slot-scope="scope">
              {{ scope.row.amountUsdt }}&nbsp;USDT
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination-box"
          background
          layout="prev, pager, next"
          :total="rewardFeeTotal"
          @current-change="getRewardFee"
          :current-page.sync="rewardFeeParam.pageNumber"
          :page-size="rewardFeeParam.pageSize"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/components/NoData/index";
export default {
  components: {
    NoData,
  },
  data() {
    return {
      tableShow: "invite_record",

      inviteRecordTotal: 0,
      inviteRecordTable: [],
      inviteRecordParam: {
        needPage: 1,
        pageNumber: 1,
        pageSize: 20,
      },
      rewardFeeTotal: 0,
      rewardFeeTable: [],
      rewardFeeParam: {
        needPage: 1,
        pageNumber: 1,
        pageSize: 20,
      },
      shareUrl: "",
      vipInfo: {
        newVipLevel: 0,
        vipLevel: "",
        inviteeSum: "- -",
        rewardWithdrawSum: "- -",
        rewardFeeSum: "- -",
        inviteCode: "",
        nextLevelTurnover: null,
        nextLevelInviteeNumber: null,
        nextLevelTurnoverEligible: "- -",
        upRewardFeeRatio: "- -",
        upupRewardFeeRatio: "- -",
        upRewardWithdraw: "- -",
        upupRewardWithdraw: "- -",
        genesis: "- -",
        inviteeNormalSum: "- -",
        inviteLev1Sum: "- -",
        inviteLev2Sum: "- -",
        last24HTradeSum: "- -",
        last24HDoneRewardFeeSum: "- -",
        imgaePosterUrl: "",
        shareUrl: "",
      },
    };
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  created() {
    if (this.user.username && window.localStorage.getItem("jwt-token")) {
      this.getVipInfo();
      this.getRewardFee();
      this.getInviteRecord();
    }
  },
  methods: {
    copyToClipboard(val) {
      navigator.clipboard
        .writeText(val)
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t("tipsVal.copySucess"),
          });
        })
        .catch((err) => {
          this.$message({
            type: "warning",
            message: this.$t("tipsVal.copyerror"),
          });
        });
    },
    tabChange(val) {
      this.tableShow = val;
    },
    getRewardFee() {
      this.$axios
        .post("/Copartner/QueryRewardFeeRecord", this.rewardFeeParam)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.rewardFeeTable = res.data.data.feeFlowRecords;
            this.rewardFeeTotal = res.data.data.total;
          }
        });
    },
    getInviteRecord() {
      this.$axios
        .post("/Copartner/QueryInviteeRecord", this.inviteRecordParam)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.inviteRecordTable = res.data.data.list;
            this.inviteRecordTotal = res.data.data.total;
          }
        });
    },
    getVipInfo() {
      this.$axios.post("/Copartner/QueryCopartnerInfo", {}).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.vipInfo = res.data.data;
          this.shareUrl = this.$shareUrl + 
            "/#/register?inviteCode=" +
            this.vipInfo.inviteCode;
          // let imgUrl = this.vipInfo.imgaePosterUrl.substring(
          //   this.vipInfo.imgaePosterUrl.indexOf("/static"),
          //   this.vipInfo.imgaePosterUrl.length,
          // );
          // this.vipInfo.imgaePosterUrl = window.location.origin + imgUrl;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.info-box {
  padding: 40px;
  background: #ffffff;
  border-radius: 22px 22px 22px 22px;
  .head-box {
    padding-bottom: 36px;
    border-bottom: 1px solid #e2e3e3;
  }
  .mt32 {
    margin-top: 32px;
  }
  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 24px;
    color: #333333;
  }
  .p2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
  }
  .p3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 18px;
    color: #333333;
  }

  .box-border-right {
    border-right: 1px solid #e2e3e3;
  }

  .box-p6 {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 18px;
    color: #333333;
  }
  .box-p7 {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 24px;
    color: #4063ff;
  }
  .box-p8 {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 14px;
    color: #4063ff;
  }
  .btn1 {
    // width: 120px;
    height: 40px;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #4063ff;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #4063ff;
	padding: 0 10px;
  }
  .btn2 {
    // width: 120px;
    height: 40px;
    cursor: pointer;
    line-height: 40px;
    text-align: center;
    background: #4063ff;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
	padding: 0 10px;
  }
  .item-box {
    display: flex;
    margin-top: 32px;
    justify-content: space-between;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .item-btn {
      gap: 32px;
      display: flex;
      align-items: center;
    }
  }
  .input-box {
    gap: 120px;
    display: flex;
    justify-content: space-between;
  }
  /deep/ .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
  }
}
.box2 {
  /deep/.table-head {
    background: rgba(234, 235, 237, 0.5);
  }
  /deep/.table-head:first-child {
    border-radius: 6px 0px 0px 6px;
  }
  /deep/.table-head:last-child {
    border-radius: 0px 6px 6px 0px;
  }
  /deep/.table-cell {
    border: none;
  }
  /deep/ .el-table__body tr.current-row > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
}

.tab-box {
  gap: 40px;
  display: flex;
  div {
    padding-bottom: 22px;
    cursor: pointer;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }
  .sel {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 16px;
    color: #4063ff;
    position: relative;
  }
}
</style>
